/**
 * This function will wrap the response into a promise, so that it will mock a response time delay as if calling the proper API.
 * @param {Object} responseObject The response object once the timeout has finished.
 * @param {boolean} willFail This allows the promise to fail, to simulate an error in the API. Defaults to false.
 */
export const AwaitResponse = (responseObject, willFail = false) => {
  // Override for mocked duration. Primarily used by Jest tests.
  const mockedDuration = parseInt(typeof process !== 'undefined' ? process?.env?.VUE_MOCKED_API_DURATION : undefined, 10) || 1000;

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      if (willFail) {
        reject(new Error('Mock API set to fail'));
      } else {
        resolve(responseObject);
      }
    }, mockedDuration);
  });
};
